import React from 'react';
import {
  Container,
} from 'react-bootstrap';

import LedgersTable from './LedgersTable';



const Account = () => (
  <Container fluid className="py-4">
    <LedgersTable />
  </Container>
  );

export default Account;

